import { render } from "./IncorrectDetailsErrorComponent.vue?vue&type=template&id=c15997fe&scoped=true"
import script from "./IncorrectDetailsErrorComponent.vue?vue&type=script&lang=js"
export * from "./IncorrectDetailsErrorComponent.vue?vue&type=script&lang=js"

import "./IncorrectDetailsErrorComponent.vue?vue&type=style&index=0&id=c15997fe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c15997fe"]])

export default __exports__